import ajax from './ajax'
const BASE_URL = '/api/v1'

// 聚类接口
export const reqCategorys = (opt) => ajax(BASE_URL + '/search', {
  query: opt.query || '', // 检索条件
  core: opt.core || '', // 库名
  facetPivot: opt.facetPivot || [], // 多级聚类
  facets: opt.facets || [], // 多个聚类 ['xx','xx']
  fq: opt.fq || []
}, 'POST')
// 检索
export const reqQuery = (opt) => ajax(BASE_URL + '/search', {
  query: opt.query || '', // 检索条件
  core: opt.core || '', // 库名
  fq: opt.fq || [],
  pageNo: opt.pageNo || 1,
  pageSize: opt.pageSize || 10,
  highLight: opt.highLight || [], // 检索高亮  xxx_HL
  sorts: opt.sorts || [{feild: 'Date', order: 'desc'}],
  searchType: opt.searchType || ''
}, 'POST')

export const reqSearch = (opt) => ajax(BASE_URL + '/search', {
  query: opt.query || '',
  fq: opt.fq || [],
  pageNo: opt.pageNo || 1,
  pageSize: 10,
  core: opt.core || 'LocalChronicleItemEdu',
  highLight: opt.highLight || [], // 检索高亮  xxx_HL
  facets: opt.facets || [], // 多个聚类 ['xx','xx']
  facetPivot: opt.facetPivot || [], // 多级聚类
  returnFeild: opt.returnFeild || [],
  sorts: opt.sorts || [{feild: 'Date', order: 'desc'}],
  searchType: opt.searchType || ''
}, 'POST')
// 条目目录
export const reqItemList = (opt) => ajax(BASE_URL + '/search', {
  fq: opt.fq || [],
  core: 'LocalChronicleItemEdu',
  searchType: 'content'
}, 'POST')
// 书内检索
export const reqInnerItemList = (opt) => ajax(BASE_URL + '/search', {
  fq: opt.fq || [],
  core: opt.core || '',
  query: opt.query || '',
  pageSize: opt.pageSize || 6,
  pageNo: opt.pageNo || 1,
  searchType: 'contentSearch'
}, 'POST')
// 4.获取用户信息
export const reqUserInfo = () => ajax(BASE_URL + '/users?' + new Date().getMilliseconds())



// WEBPACK FOOTER //
// ./src/api/index.js